import axios from 'axios'

const flaskApi = axios.create({
  baseURL: '/api/admin/v2',
  withCredentials: true,
})

flaskApi.interceptors.request.use(async (config) => {
  const method = (config.method ?? 'get').toLowerCase()
  if (method !== 'get' && method !== 'head' && method !== 'options') {
    const hasCsrfCookie = document.cookie.includes('admin_csrf_token')
    if (!hasCsrfCookie) {
      await flaskApi.get('/auth/csrf-token')
    }
    const match = document.cookie.match(/(?:^|;\s*)admin_csrf_token=([^;]*)/)
    if (match) {
      config.headers['X-CSRFToken'] = match[1]
    }
  }
  return config
})

export { flaskApi }
